import React from 'react';
import { oneOf, string } from 'prop-types';
import classNames from 'classnames';
import { Icon } from '@fiverr-private/fit';
import { BASE_CLASS, STAR_ICON_CONFIG, STAR_SIZE, THEMES } from './constants';

const Star = ({ className, theme = THEMES.EMPTY }) => {
    const wrapperClasses = classNames(
        BASE_CLASS,
        className
    );

    return (
        <Icon className={wrapperClasses} size={STAR_SIZE}>
            {STAR_ICON_CONFIG[theme]}
        </Icon>
    );
};

Star.propTypes = {
    /**
     * A className to be appended
     */
    className: string,
    /**
     * The star's theme.
     * Supported options are exposed through the static `THEMES` property.
     */
    theme: oneOf(Object.values(THEMES))
};

Object.assign(Star, {
    THEMES
});

export default Star;
